import { Injectable } from '@angular/core';

import * as jsPDF from 'jspdf';
import { FontBase64 } from '../__model/font-base64.model';

@Injectable()

export class JsPDFFontService {

    AddFontRoboto(doc: jsPDF) {
        (doc as any).addFileToVFS('Roboto-Regular.ttf', FontBase64.RobotoFont);
        (doc as any).addFileToVFS('Roboto-Bold.ttf', FontBase64.RobotoBold);
        (doc as any).addFileToVFS('Roboto-Italic.ttf', FontBase64.RobotoItalic);
        (doc as any).addFileToVFS('Roboto-BoldItalic.ttf', FontBase64.RobotoBoldItalic);
        doc.addFont('Roboto-Regular.ttf', 'Roboto-Regular', 'normal');
        doc.addFont('Roboto-Bold.ttf', 'Roboto-Regular', 'bold');
        doc.addFont('Roboto-Italic.ttf', 'Roboto-Regular', 'italic');
        doc.addFont('Roboto-BoldItalic.ttf', 'Roboto-Regular', 'bolditalic');
        doc.setFont('Roboto-Regular');
    }
}